import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  DeleteApiDependentMutationResponse,
  DeleteApiDependentQueryParams,
  DeleteApiDependent401,
  DeleteApiDependent403,
} from "../../../types/DeleteApiDependent";

export function getDeleteApiDependentUrl() {
  return `/api/Dependent` as const;
}

/**
 * {@link /api/Dependent}
 */
export async function deleteApiDependent(
  params?: DeleteApiDependentQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    DeleteApiDependentMutationResponse,
    ResponseErrorConfig<DeleteApiDependent401 | DeleteApiDependent403>,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiDependentUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
